import React, { Component, Fragment } from 'react';
import update from 'immutability-helper';

import InlineAlert from '../../../utilities/form-components/InlineAlert';
import { hostServer } from '../../../utilities/UrlPaths';

const clearFilterMessage = 'Clear Filter';
const reviewMessages = {
  banned: 'Review all banned items.',
  potentiallyBanned: 'Review all potentially banned items.',
  unpublished: 'Review all unpublished items.',
  restricted: 'Review all payment restricted items.',
  images: 'Review all items without images.',
  unlotted: 'Review all unlotted items.'
};

const originalState = {
  banned: {
    message: reviewMessages.banned,
    show: true,
  },
  potentiallyBanned: {
    message: reviewMessages.potentiallyBanned,
    show: true,
  },
  unpublished: {
    message: reviewMessages.unpublished,
    show: true,
  },
  restricted: {
    message: reviewMessages.restricted,
    show: true,
  },
  images: {
    message: reviewMessages.images,
    show: true,
  },
  unlotted: {
    message: reviewMessages.unlotted,
    show: true,
  }
};

class Step6Banners extends Component {
  constructor(props) {
    super(props);
    this.state = originalState;
  }

  static getDerivedStateFromProps(props) {
    // (bnikom) if the filter list is the same the pure list reset the banners
    if (props.lengthCheck) {
      return originalState;
    }
    return null;
  }

  render() {
    const {
      handleBannerFilter,
      isBanned,
      isPotentiallyBanned,
      isRestricted,
      isUnpublished,
      noImage,
      isUnlottedItems,
    } = this.props;
    const { banned, images, restricted, potentiallyBanned, unpublished, unlotted } = this.state;

    const marketingPolicyLink = (type) => (
      <a
        href={`${hostServer}/inv/help-center/resource/invaluable-marketplace-standards/`}
        key={type}
        target="_blank"
        rel="noopener noreferrer"
      >
        Marketplace Standards Policy
      </a>
    );

    const handleBannerMessage = (e, type) => {
      let newState = this.state;
      const isClear = e.target.value === clearFilterMessage;
      /**
       * (bnikom) create a copy of state, and use an immutability helper
       * so that this.state does not change, only newState
       */
      Object.keys(newState).forEach((key) => {
        newState = update(newState, {
          [key]: {
            $merge: {
              message: (isClear) ? reviewMessages[key] : clearFilterMessage,
              /**
              * (bnikom)
              * don't show banner if:
              * 1: the banner is NOT the type selected by the user (key !== type)
              * 2: if user has NOT clicked to clear filter (!isClear)
              * both properties exist = true (key !== type && !isClear)
              * but to HIDE/NOT show we need show === false so add !
              * aka. !(key !== type && !isClear)
              */
              show: !(key !== type && !isClear),
            }
          }
        });
      });
      this.setState(newState);
      handleBannerFilter(type, isClear);
    };

    const reviewItems = (key, reviewText, type) => (
      <button
        key={key}
        className="btn-link bg-transparent border-0 pl-1"
        onClick={e => { handleBannerMessage(e, type); }}
        value={reviewText}
        type="button"
      >
        {reviewText}
      </button>
    );

    const renderBannedBanner = (
      <InlineAlert
        baseText={['Some items below have been flagged in violation of our ',
          marketingPolicyLink('bannedMarket'),
          '. Online bidding will be disabled for these items on Invaluable and AuctionZip. ',
          reviewItems('bannedReview', banned.message, 'banned')]}
        color="danger"
        icon="ban"
        titleText="Banned Items"
        showPhones={false}
        uncontrolled={false}
      />
    );

    const renderPotenBannedBanner = (
      <InlineAlert
        baseText={['Some items below have been flagged as potentially violating our ',
          marketingPolicyLink('potenBanMarket'), '. ',
          reviewItems('potenBanReview', potentiallyBanned.message, 'potentiallyBanned')]}
        color="warning"
        icon="ban"
        titleText="Potentially Banned Items"
        showPhones={false}
        uncontrolled={false}
      />
    );

    const renderUnpublishedBanner = (
      <InlineAlert
        baseText={['Some items below have not been published. ',
          reviewItems('unpubReview', unpublished.message, 'unpublished')]}
        color="danger"
        icon="upload"
        titleText="Unpublished Items"
        showPhones={false}
        uncontrolled={false}
      />
    );

    const renderPayRestrictBanner = (
      <InlineAlert
        baseText={['Some items for this session are online payment restricted based on our Payment Processing Policy. ',
          reviewItems('payRestReview', restricted.message, 'restricted')]}
        color="warning"
        icon="credit-card"
        titleText="Payment Restricted Items"
        showPhones={false}
        uncontrolled={false}
      />
    );

    const renderImagesBanner = (
      <InlineAlert
        baseText={['Some items for this session do not have images. ',
          reviewItems('noImageReview', images.message, 'images')]}
        color="danger"
        icon="image"
        titleText="Items Without Images"
        showPhones={false}
        uncontrolled={false}
      />
    );

    const renderUnlottedItemsBanner = (
      <InlineAlert
        baseText={['Some items below do not have a lot number. Please make sure all items have a lot number or inventory number. ',
          reviewItems('unlottedReview', unlotted.message, 'unlotted')]}
        color="warning"
        icon="upload"
        titleText="Unlotted Items"
        showPhones={false}
        uncontrolled={false}
      />
    );

    return (
      <Fragment>
        {banned.show && isBanned && renderBannedBanner}
        {potentiallyBanned.show && isPotentiallyBanned && renderPotenBannedBanner}
        {unpublished.show && isUnpublished && renderUnpublishedBanner}
        {restricted.show && isRestricted && renderPayRestrictBanner}
        {images.show && noImage && renderImagesBanner}
        {unlotted.show && !isUnlottedItems && renderUnlottedItemsBanner}
      </Fragment>
    );
  }
}

export default Step6Banners;
